module.exports = __webpack_public_path__ + "img/privilege15.55ffc0cd.png";